import type { TeamMember } from 'src/app/pages/about/team/pageContext';

type Result = ModelHookResult<{
	photoUrl: string | undefined;
}>;

export function useTeamMemberCard(member: TeamMember): Result {
	return {
		data: {
			photoUrl: !member.user.photo?.userLarge.processing ? member.user.photo?.userLarge.url : undefined,
		},
	};
}
